export default __webpack_public_path__ + "static/media/piano.362f0859.jpg";